/**
 * Opens external links in a new tab, site-wide.
 *
 * Loaded from theme.liquid only when the "Open external links in a new tab"
 * theme setting is enabled. Runs as a self-contained IIFE — no global scope
 * pollution, no changes to base theme JS.
 *
 * An external link is any http(s) anchor whose hostname differs from the page
 * the visitor is currently on. mailto:, tel:, anchor (#) and same-domain links
 * are skipped automatically, as are links already set to open in a new tab.
 */
(function () {
  var currentHost = window.location.hostname;

  function isExternal(link) {
    // Only real web links — skips mailto:, tel:, javascript:, in-page anchors, etc.
    if (link.protocol !== 'http:' && link.protocol !== 'https:') return false;
    return link.hostname !== '' && link.hostname !== currentHost;
  }

  function applyTo(link) {
    if (!(link instanceof HTMLAnchorElement)) return;
    if (link.target === '_blank') return;
    if (!isExternal(link)) return;

    link.target = '_blank';

    // Preserve any existing rel tokens; add noopener/noreferrer for safety.
    var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    ['noopener', 'noreferrer'].forEach(function (token) {
      if (rel.indexOf(token) === -1) rel.push(token);
    });
    link.setAttribute('rel', rel.join(' '));
  }

  function scan(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    if (root instanceof HTMLAnchorElement) applyTo(root);
    root.querySelectorAll('a[href]').forEach(applyTo);
  }

  function init() {
    scan(document.body);

    // Catch links injected after load (cart drawer, quick add, predictive search, etc.)
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
